export default function LandingSaveToRich() {
  return (
    <div className="page">
      <header className="nav">
        <div className="container navInner">
          <div className="brand">
            <img src="/logo.png" width={80} />
          </div>

          <a
            className="btn primary"
            href="/login"
            onClick={() => window.ym?.(106217047, 'reachGoal', 'Перейти на страницу регистрации')}
          >
            Попробовать
          </a>
        </div>
      </header>

      <section className="hero">
        <div className="container heroGrid" style={{ display: 'grid', justifyItems: 'center' }}>
          <div className="heroLeft" style={{ maxWidth: 720, textAlign: 'center' }}>
            <div className="pill">📌 • учёт финансов • просто и быстро</div>

            <h1 className="h1">
              Контролируй деньги.
              <br />
              Расти быстрее.
            </h1>

            <p>
              SaveToRich — приложение для учёта доходов и расходов: добавляй операции за секунды,
              группируй по категориям и тегам, смотри аналитику по месяцам и принимай решения на
              цифрах.
            </p>

            <div className="actions">
              <a
                className="btn primary"
                href="/login"
                onClick={() =>
                  window.ym?.(106217047, 'reachGoal', 'Перейти на страницу регистрации')
                }
              >
                Зарегистрироваться
              </a>
            </div>

            <div className="stats">
              <div className="stat">
                <b>Быстро</b>
                <span>добавление операций за пару кликов</span>
              </div>
              <div className="stat">
                <b>Наглядно</b>
                <span>категории, теги и аналитика</span>
              </div>
              <div className="stat">
                <b>Удобно</b>
                <span>работает как приложение на телефоне</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="demo" className="section">
        <div className="container">
          <div className="demoGrid">
            <div className="card">
              <div className="cardMedia">
                <div className="phoneFrame" aria-label="Видео демо">
                  <div className="notch" aria-hidden="true" />

                  <video className="media" controls playsInline preload="metadata">
                    <source src={'/landing/video.mp4'} type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="section">
        <div className="container">
          <h2 className="h2">Особенности SaveToRich</h2>
          <p className="muted">Ключевые фишки, которые пользователь ощущает сразу.</p>

          <div className="grid3">
            <Feature
              icon="⚡"
              title="Быстрое добавление"
              text="Доход или расход — в пару кликов, без лишних экранов."
            />
            <Feature
              icon="🏷️"
              title="Категории и теги"
              text="Гибкая структура: что важно — то и выделяешь."
            />
            <Feature
              icon="📊"
              title="Понятная аналитика"
              text="Динамика по месяцам и понимание, куда уходят деньги."
            />
            <Feature
              icon="🔎"
              title="Фильтры и поиск"
              text="Находи операции по тексту, тегам, категориям и датам."
            />
            <Feature
              icon="📱"
              title="PWA: как приложение"
              text="Добавляется на главный экран и открывается мобильное приложение."
            />
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="how" className="section">
        <div className="container">
          <h2 className="h2">Как это работает</h2>
          <p className="muted">Три шага, чтобы начать контролировать бюджет.</p>

          <div className="grid3">
            <Step
              n={1}
              title="Добавь операции"
              text="Фиксируй доходы и расходы, указывай категорию и теги."
            />
            <Step
              n={2}
              title="Сгруппируй"
              text="Категории дают структуру, теги — гибкую аналитику."
            />
            <Step
              n={3}
              title="Смотри аналитику"
              text="Понимай, где можно оптимизировать и расти быстрее."
            />
          </div>
        </div>
      </section>

      <style>{css}</style>
    </div>
  );
}

function Feature({ icon, title, text }: { icon: string; title: string; text: string }) {
  return (
    <div className="miniCard">
      <div className="featureIcon" aria-hidden="true">
        {icon}
      </div>
      <h3 className="h3">{title}</h3>
      <p className="mutedSmall">{text}</p>
    </div>
  );
}

function Step({ n, title, text }: { n: number; title: string; text: string }) {
  return (
    <div className="miniCard">
      <div className="num">{n}</div>
      <h3 className="h3">{title}</h3>
      <p className="mutedSmall">{text}</p>
    </div>
  );
}

const css = `
:root{
  --bg:#0b0b0f;
  --card:#111118;
  --text:#f5f5f7;
  --muted:#a0a0ad;
  --line:rgba(255,255,255,.08);
  --accent:#7c5cff;
  --accent2:#22c55e;
  --radius:18px;
  --shadow: 0 20px 60px rgba(0,0,0,.55);
  --max: 1120px;
}

*{ box-sizing:border-box; }
html,body{ height:100%; }
body{
  margin:0;
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial;
  background:
    radial-gradient(1200px 600px at 20% 0%, rgba(124,92,255,.25), transparent 60%),
    radial-gradient(900px 500px at 80% 10%, rgba(34,197,94,.12), transparent 55%),
    var(--bg);
  color:var(--text);
}
a{ color:inherit; text-decoration:none; }
code{ background: rgba(255,255,255,.06); padding:2px 6px; border-radius:8px; border:1px solid var(--line); }

.page{ min-height:100vh; }

.container{
  max-width: var(--max);
  margin: 0 auto;
  padding: 0 20px;
}

.nav{
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(10px);
  background: rgba(11,11,15,.65);
  border-bottom: 1px solid var(--line);
}

.navInner{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 14px 0;
  gap: 12px;
}

.featureIcon{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display:flex;
  align-items:center;
  justify-content:center;
  border: 1px solid rgba(255,255,255,.10);
  background: rgba(255,255,255,.04);
  font-size: 20px;
  margin-bottom: 10px;
}

.brand{
  display:flex;
  align-items:center;
  gap: 10px;
  font-weight: 800;
}

.brandName{ letter-spacing: .2px; }

.logo{
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--accent), #3b82f6);
  box-shadow: 0 10px 30px rgba(124,92,255,.35);
}

.links{
  display:flex;
  gap: 18px;
  color: var(--muted);
  font-size: 14px;
}
.links a:hover{ color: var(--text); }

.btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  padding: 12px 16px;
  border-radius: 14px;
  border: 1px solid var(--line);
  background: rgba(255,255,255,.04);
  color: var(--text);
  font-weight: 700;
  transition: .15s ease;
  cursor: pointer;
  white-space: nowrap;
}
.btn:hover{ transform: translateY(-1px); border-color: rgba(255,255,255,.16); }
.btn.primary{
  background: linear-gradient(135deg, var(--accent), #3b82f6);
  border: none;
  box-shadow: 0 18px 40px rgba(124,92,255,.28);
}

.hero{
  padding: 64px 0 36px;
}

.heroGrid{
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center; /* центрирует heroLeft */
}

.heroLeft{
  max-width: 720px;      /* чтобы не растягивалось на всю ширину */
  text-align: center;    /* текст по центру */
}

.actions{
  display: flex;
  justify-content: center; /* кнопка по центру */
}

.stats{
  justify-items: center; /* если stats grid */
}
.pill{
  display:inline-flex;
  gap: 10px;
  align-items:center;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255,255,255,.04);
  border: 1px solid var(--line);
  color: var(--muted);
  font-size: 13px;
}

.h1{
  margin: 14px 0 12px;
  font-size: 46px;
  line-height: 1.05;
}

.h2{
  margin: 0 0 10px;
  font-size: 28px;
}

.h3{
  margin: 10px 0 6px;
  font-size: 16px;
}

.lead{
  margin: 0;
  color: var(--muted);
  font-size: 16px;
  line-height: 1.6;
  max-width: 54ch;
}

.actions{
  margin-top: 18px;
  display:flex;
  gap: 12px;
  flex-wrap: wrap;
}

.stats{
  margin-top: 22px;
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.stat{
  background: rgba(255,255,255,.03);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 14px;
}
.stat b{ display:block; font-size: 18px; }
.stat span{ color: var(--muted); font-size: 13px; }

.section{ padding: 52px 0; }

.muted{ margin:0; color: var(--muted); line-height: 1.6; }
.mutedSmall{ margin:0; color: var(--muted); font-size: 14px; line-height: 1.6; }

.card{
  background: linear-gradient(180deg, rgba(255,255,255,.04), rgba(255,255,255,.02));
  border: 1px solid var(--line);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  overflow: hidden;
}

.cardHead{
  padding: 14px 16px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  border-bottom: 1px solid var(--line);
}

.cardBody{
  padding: 16px;
}

.badge{
  font-size: 12px;
  color: var(--muted);
  padding: 6px 10px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: rgba(0,0,0,.18);
}

.checklist{
  margin: 0;
  padding-left: 18px;
  color: var(--muted);
  line-height: 1.8;
}

.demoGrid{
  display:grid;
 justify-items: center; 
}

.footer {
overflow: hidden;
}

.cardMedia{
  padding: 18px;
  display:flex;
  justify-content:center;
}

.phoneFrame{
  width: 416px;
  height: 848px;
  border-radius: 34px;
  background: #0f0f15;
  border: 1px solid rgba(255,255,255,.10);
  box-shadow: 0 30px 70px rgba(0,0,0,.6);
  overflow: hidden;
  position: relative;
}

.posterFrame{
  width: 589px;
  height: 1280px;
  border-radius: 26px;
  background: #0f0f15;
  border: 1px solid rgba(255,255,255,.10);
  box-shadow: 0 30px 70px rgba(0,0,0,.6);
  overflow: hidden;
  position: relative;
}

.notch{
  position:absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 140px;
  height: 26px;
  border-radius: 999px;
  background: rgba(255,255,255,.06);
  border: 1px solid rgba(255,255,255,.08);
  z-index: 2;
}

.media{
  width: 100%;
  height: 100%;
  display:block;
  object-fit: cover;
  background: linear-gradient(135deg, rgba(124,92,255,.18), rgba(34,197,94,.10));
}

.placeholder{
  width: 100%;
  height: 100%;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  text-align:center;
  color: var(--muted);
  background: linear-gradient(135deg, rgba(124,92,255,.14), rgba(34,197,94,.08));
}
.placeholderTitle{
  color: var(--text);
  font-weight: 800;
  font-size: 18px;
}
.placeholderText{
  font-size: 13px;
  line-height: 1.5;
  max-width: 44ch;
}

.grid3{
  margin-top: 20px;
  display:grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.miniCard{
  padding: 16px;
  border-radius: var(--radius);
  border: 1px solid var(--line);
  background: rgba(255,255,255,.03);
}

.icon{
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: rgba(124,92,255,.18);
  border: 1px solid rgba(124,92,255,.35);
}

.num{
  width: 32px;
  height: 32px;
  border-radius: 12px;
  display:flex;
  align-items:center;
  justify-content:center;
  background: rgba(34,197,94,.14);
  border: 1px solid rgba(34,197,94,.30);
  color: var(--text);
  font-weight: 900;
}

.cta{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap: 16px;
  padding: 18px;
}

.ctaButtons{
  display:flex;
  gap: 10px;
  flex-wrap: wrap;
}

.footer{
  padding: 28px 0 44px;
  color: var(--muted);
  border-top: 1px solid var(--line);
}
.footerInner{
  display:flex;
  justify-content:space-between;
  gap: 12px;
  flex-wrap: wrap;
}

/* Responsive */
@media (max-width: 980px){
  .heroGrid{ grid-template-columns: 1fr; }
  .h1{ font-size: 36px; }
  .stats{ grid-template-columns: 1fr; }
  .demoGrid{ grid-template-columns: 1fr; }
  .grid3{ grid-template-columns: 1fr; }
  .cta{ flex-direction: column; align-items: flex-start; }
  .links{ display:none; }

  .phoneFrame{ width: 320px; height: 650px; }
  .posterFrame{ width: 320px; height: 696px; }
}
`;
